import { PropsWithChildren } from "react";
import styles from "./error-message.module.css";
import { cn } from "@/lib/utils.ts";

/**
 * Props for the ErrorMessage component
 */
interface ErrorMessageProps extends PropsWithChildren {
    /** Whether the error message is a warning */
    isWarning?: boolean;
}

/**
 * Component that renders an error message
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, isWarning = false }) => {
    return <p className={cn(isWarning ? styles.warning : styles.error)}>{children}</p>;
};
